import { TezaurusDeleteApi } from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import Uuid from '../../model/Uuid';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new TezaurusDeleteApi(apiConfiguration(tezauryPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const deleteTezaurus = async (
  uuid: Uuid,
  options: { headers?: AxiosRequestHeaders } = {},
):
  Promise<ClientResponse<void>> => {
  const { status } = await client.deleteTezaurus(uuid, options);
  return {
    responseCode: status,
  };
};
